import { FC, useEffect, useRef, useState } from 'react';
import { TooltipProps } from './types';
import { TooltipContainer, TooltipLabel } from './styles';

export const Tooltip: FC<TooltipProps> = ({ children, label }) => {
  const tooltipContainer = useRef<HTMLDivElement | null>(null);
  const tooltipLabel = useRef<HTMLDivElement | null>(null);

  const [ positionStyle, setPositionStyle ] = useState<any>({});

  const setPosition = () => {
    if (!tooltipLabel.current||!tooltipContainer.current) return;

    const labelRect = tooltipLabel.current.getBoundingClientRect();

    const labelWidth = labelRect.width;
    const labelLeftPos = labelRect.left;
    const labelRightPos = window.innerWidth - (labelWidth + labelLeftPos);

    const style = {} as any;

    if (labelLeftPos < 40) {
      style.left = 0;

      return setPositionStyle(style)
    }

    if (labelRightPos < 40) {
      style.right = 0;

      return setPositionStyle(style)
    }
  }

  useEffect(() => {
    if (tooltipLabel.current&&tooltipContainer.current) {
      setPosition()
    }
  }, [tooltipContainer, tooltipLabel])

	return (
		<TooltipContainer ref={tooltipContainer}>
			{children}
			<TooltipLabel ref={tooltipLabel} style={positionStyle}>{label}</TooltipLabel>
		</TooltipContainer>
	);
};
